import moment from 'moment';
import { stripBarcodeTerminators } from '../misc';

// NOTE: if just after midnight, only use the date component
/* const formatOfferDate = (date: string) => {
  const formatted = formatDate(date, 'DD/MM/YYYY h:mmA');

  return formatted ? formatted.replace(/\s+12:0.AM$/, '') : undefined;
}; */

export default function processMemberOffers(raw: RawOffer) {
  // Note: we are using moment to compare dates because it's more accurate than new Date()
  // new Date() is not accurate because it's not timezone aware
  // moment is timezone aware and can be used to compare dates
  // on Android the new Date().getTime() would be on 12 hour time format and iOS is on 24 hour time format
  return {
    id: raw.ID,
    barcode: raw.Barcode,
    hash: stripBarcodeTerminators(raw.Hash),
    name: raw.ProgramName,
    description: raw.Description,
    longDescription: raw.LongDescription,
    image: raw.ImageURL,
    redeemed: !!raw.Redeemed,
    couponProgram: raw.ProgramID,
    startDate: moment(raw.StartDate).toISOString(),
    expiryDate: moment(raw.ExpiryDate).toISOString(),
    formattedStartDate: new Date(raw.StartDate).toLocaleDateString(),
    formattedExpiryDate: new Date(raw.ExpiryDate).toLocaleDateString(),
    expired:
      !!raw.ExpiryDate && moment(raw.ExpiryDate).valueOf() < moment().valueOf(),
    unstarted:
      !!raw.StartDate && moment(raw.StartDate).valueOf() > moment().valueOf(),
  };
}
